<template>
  <b-row class="match-height m-0">
    <div class="container-img-ai">

      <!-- Options controls left -->
      <div class="slider-card-left active-slider" ref="slider-left">
        <sider-left-sections 
          :category_selected="category_selected" 
          :credits="credits" 
          @show_modal_update_suscription="openModalMembership"
          @update-section="category_selected = { section: $event.section, category: $event.category }"
          :all_plans="all_plans"
          :favorites_assistants="favoriteAssistants"
          :recent_assistants="recentAssistants"
        ></sider-left-sections>
      </div>
      <b-sidebar class="sidebar-left-sections" v-model="open_sidebar_left" shadow>
        <sider-left-sections 
          :category_selected="category_selected" 
          :credits="credits" 
          @show_modal_update_suscription="openModalMembership"
          @update-section="category_selected = { section: $event.section, category: $event.category }"
          :all_plans="all_plans"
          :favorites_assistants="favoriteAssistants"
          :recent_assistants="recentAssistants"
        ></sider-left-sections>
      </b-sidebar>
      <!-- ----------------- -->
    
      <div class="card-content-center active-content-left" ref="content-center">
        <!-- Options layout grid, export -->

        <!-- ------------------- -->
        
        <div class="container-search">
          <!-- Container results -->
  
          <!-- Container generate images  -->
          <container-grid
            :credits_avaible="credits"
            @slide_window="slideWindow"
            @update_credits="updateCredits"
            v-if="category_selected.section === 'image' && category_selected.category === 'txt-to-image'"
          ></container-grid>

          <!-- Container reimagine  -->
          <container-reimagine
            :credits_avaible="credits"
            @slide_window="slideWindow"
            @update_credits="updateCredits"
            @show_modal_update_suscription="openModalMembership"
            v-if="category_selected.section === 'image' && category_selected.category === 'reimagine'"
          ></container-reimagine>
          <!-- -------------------------- -->

          <!-- Container history -->
          <history-grid 
            @slide_window="slideWindow"
            @edit_history="editHistory"
            @back_history="editHistory"
            v-if="category_selected.section === 'histories'"
          ></history-grid>
          <!-- -------------------->

          <!-- Container comminity -->
          <community-grid 
            @slide_window="slideWindow"
            :category_selected="category_selected"
            v-if="category_selected.section === 'community'"
          ></community-grid>
          <!-- -------------------- -->

          <!-- Container Chat -->
          <chat
            :credits_avaible="credits"
            :category_selected="category_selected"
            :data_settings="assistant_settings"
            @slide_window="slideWindow"
            @update-settings="onUpdateAssistantSettings"
            @update_credits="updateCredits"
            @redirect-explore-assistants="category_selected = { section: 'assistants', category: 'personas' }; $router.push({ name: 'brandme_AI', params: { section: 'assistants', category: 'personas' }}).catch(() => {})"
            v-if="category_selected.section === 'chat'"
          ></chat>

          <!-- Container Text -->
          <text-container
            :credits_avaible="credits"
            :category_selected="category_selected"
            @slide_window="slideWindow"
            @update_credits="updateCredits"
            @back_history="editHistory"
            v-if="category_selected.section === 'text'"
          ></text-container>
          <!-- -------------------- -->

          <!-- Container Assistants -->
          <container-assistants
            :category_selected="category_selected"
            :credits_avaible="credits"
            @slide_window="slideWindow"
            @update_credits="updateCredits"
            :data_settings="assistant_settings"
            @update-settings="onUpdateAssistantSettings"
            @assistant-selected="assistantSelectedRedirect"
            @redirect-explore-assistants="category_selected = { section: 'assistants', category: 'personas' }; $router.push({ name: 'brandme_AI', params: { section: 'assistants', category: 'personas' }}).catch(() => {})"
            v-if="category_selected.section === 'assistants'"
          ></container-assistants>
          <!-- -------------------- -->

           <!-- Container Video -->
           <video-grid
            :credits_avaible="credits"
            @slide_window="slideWindow"
            @update_credits="updateCredits"
            @show_modal_update_suscription="openModalMembership"
            v-if="category_selected.section === 'video'"
          ></video-grid>
          <!-- -------------------- -->

          <!-- Container AI Contents (superusers only) -->
          <contents-container
            :credits="credits"
            @slide_window="slideWindow"
            @refresh_credits="getSummaryCredits"
            v-if="category_selected.section === 'contents' && is_superuser"
          ></contents-container>
          <!-- -------------------- -->
        </div>
      </div>
    </div>
    <modal-membership-group
      :open_modal_plans_group="open_modal_plans_group" 
      :key="update_modal"
      :month_dad="true"
      :texts="data_modal_membership"
    />
  </b-row>
</template>

<script>
import {
  BRow,
  VBToggle,
  BSidebar,
} from "bootstrap-vue";
import { getSummaryCredits, getSettings } from '@/services/ia'
import service from "@/services/proposals";
import { separatebycomma } from '@/libs/utils/formats'
import { getUserData } from '@/libs/utils/user'

export default {
  name: "brandmeAI",
  components: {
    BRow,
    BSidebar,
    videoGrid: () => import('@/views/components/brandme-ai/videoGrid.vue'),
    historyGrid: () => import('@/views/components/brandme-ai/historyGrid.vue'),
    communityGrid: () => import('@/views/components/brandme-ai/communityGrid.vue'),
    chat: () => import('@/views/components/brandme-ai/chat.vue'),
    containerGrid: () => import('@/views/components/brandme-ai/containerGrid.vue'),
    ContainerReimagine: () => import('@/views/components/brandme-ai/ContainerReimagine.vue'),
    siderLeftSections: () => import('@/views/components/brandme-ai/siderbars/siderLeftSections.vue'),
    ModalMembershipGroup: () => import('@/views/components/modal/ModalMembershipGroup.vue'),
    textContainer: () => import('@/views/components/brandme-ai/textContainer.vue'),
    ContainerAssistants: () => import('@/views/components/brandme-ai/ContainerAssistants.vue'),
    ContentsContainer: () => import('@/views/components/brandme-ai/contents/ContentsContainer.vue'),
  },
  directives: {
    'b-toggle': VBToggle
  },
  data() {
    return {
      separatebycomma,
      category_selected: {
        section: '',
        category: ''
      },
      open_sidebar_left: false,
      credits: 0,
      all_plans: [],
      open_modal_plans_group: false,
      update_modal: false,
      data_modal_membership: {},
      assistant_settings: null,
    };
  },
  created() {
    this.$store.commit('appConfig/UPDATE_FOOTER_CONFIG', { type: 'hidden' });
    this.category_selected = this.$route.params;
    if (this.category_selected.section === 'contents' && !this.is_superuser) {
      this.category_selected = { section: 'image', category: 'txt-to-image' };
      this.$router.replace({ name: 'brandme_AI', params: this.category_selected }).catch(() => {});
    }
    this.getSummaryCredits();
    this.getPlansMembers();
    this.getAssistantSettings();
  },
  destroyed() {
    this.$store.commit('appConfig/UPDATE_FOOTER_CONFIG', { type: 'static' });
  },
  watch: {
    // AI Contents navigates between its views internally; keep the sidebar selection in sync
    '$route.params.category'(category) {
      if (this.$route.params.section === 'contents') this.category_selected = { section: 'contents', category: category || 'history' };
    },
  },
  computed: {
    is_superuser() {
      const user = getUserData();
      return !!(user && user.is_superuser);
    },
    favoriteAssistants() {
      if (!this.assistant_settings || !this.assistant_settings.favorites_options) return [];
      return this.assistant_settings.favorites_options.map(f => ({
        title: f.name || f.slug,
        category: f.slug,
        favorite: true,
      }));
    },
    recentAssistants() {
      if (!this.assistant_settings || !this.assistant_settings.recent_options) return [];
      return this.assistant_settings.recent_options.map(r => ({
        title: r.name || r.slug,
        category: r.slug,
        recent: true,
      }));
    }
  },
  methods: {
    getPlansMembers() {
      service.getPlan().then((response) => {
        this.all_plans = response.results;
      });
    },
    openModalMembership(data) {
      this.data_modal_membership = (data && Object.keys(data).length > 0) ? data : {};
      if (this.credits <= 200) {
        this.open_modal_plans_group = true; 
        this.update_modal = !this.update_modal;
      }
    },
    assistantSelectedRedirect(assistant) {
      this.category_selected = { section: 'assistants', category: assistant.slug };
      this.$router.push({ name: 'brandme_AI', params: { section: 'assistants', category: assistant.slug }}).catch(() => {})
    },
    editHistory(data = 'image', category = null) {
      switch (data) {
      case 'image':
        this.category_selected = { section: 'image', category: 'txt-to-image' };
        break;
      case 'reimagine':
        this.category_selected = { section: 'image', category: 'reimagine' };
        break;
      case 'video':
        this.category_selected = { section: 'video', category: 'talking-portrait' };
        break;
      case 'text':
        this.category_selected = { section: 'text', category: category || 'social-post' };
        break;
      case 'history':
        this.category_selected = { section: 'histories', category: 'text' };
        break;
      }
    },
    slideWindow() {
      this.open_sidebar_left = !this.open_sidebar_left;
      const slideSide = this.$refs['slider-left'];
      const contentCenter = this.$refs['content-center'];
      slideSide.classList.toggle("active-slider")
      contentCenter.classList.toggle("active-content-left")
    },
    updateCredits(credits_used) {
      this.credits -= credits_used;
    },
    getSummaryCredits() {
      getSummaryCredits().then((response) => {
        this.credits = response.credits_available;
      })
    },
    getAssistantSettings() {
      getSettings().then((response) => {
        this.assistant_settings = response;
      }).catch(() => {})
    },
    onUpdateAssistantSettings(newSettings) {
      this.assistant_settings = newSettings;
    }
  },
};
</script>
<style scoped lang="scss">
.sidebar-left-sections {

  display: none;
}
.white-space-pre-wrap {
  white-space: pre-wrap;
}

.match-height {
  height: 78vh;
}
.container-img-ai{
  display: flex;
  flex-direction: row; 
  height: 100%;
  width: 100%;

  @media(max-width: 500px) {
    height: 78vh;
  }
}

.slider-card-left {
  width: 290px;
  flex-shrink: 0;
  background-color: white;
  height: 100%;
  transform: translateX(-340px);
  margin-right: -290px;
  transition: all 700ms ease-in-out;
  box-shadow: 0 4px 24px 0 rgba(34, 41, 47, 0.1);
  border-top-left-radius: 0.428rem;
  border-bottom-left-radius: 0.428rem;
}
.active-slider {
  width: 290px;
  transform: translateX(0px);
  margin-right: 0px;
  flex-shrink: 0;
}

.card-content-center{
  width: 100%;
  height: 100%;
  transition: all 700ms ease;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  background-color: white;
}
/* .active-content-left se deja sin estilos explícitos; regla vacía eliminada */
.p-1rem{
  padding: 1rem;
}
.width-right-area{
  width: 24%;
  height: 100%;
}
.size-icons-left {
  width: 2.4rem;
  height: 2.4rem;
  margin-right: 0.5rem;
}
.size-img-icon {
  width: 20px;
  height: 20px;
}

.pos-relative{
  position: relative;
}
.image-size-active-slide {
  width: 33%;
  padding: 0.5em;
}
.w-50{
  width: 50%;
  padding: 0.3em 0.5em;
}

.p-left{
  padding: 10px 12px;
}

.container-search {
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
  overflow-y: scroll;
  padding-right: 4px;

  justify-content: flex-start;
  position: relative;
}

.options-button-panel{
  display: flex;
  flex-direction: row;
  align-items: center;
}
.body-button-center{
  position: relative;
  background-color: #e9ecef;
  padding: .25rem .25rem;
  border-radius: .375rem;
}

.toggle-hover:hover{
  cursor: pointer;
}

@media (max-width: 1199px) {
  .match-height {
    height: 89vh;
  }

  .width-right-area{
    display: none;
  }
  .container-img-ai{ 
    width: 100%;
  }
  .background-input-botton{
    width: 100%;
    height: auto;
  }
}

@media (max-width: 800px) {

  .slider-card-left {
    display: none;
  }
  .sidebar-left-sections {
    display: block;
  }
}
@media (max-width: 770px) {

  .image-size-active-slide{
    width: 50%;
  }
  .max-width-disabled{
    display: none;
  }
  .size-drop-responsive{
    display: flex;
  }
  .active-slider{
    width: 50%;
}
}
@media (max-width: 513px) {
  .image-size-active-slide{
    width: 100%;
  }
}
</style>

<style lang="scss">
.sidebar-left-sections .b-sidebar {
  background-color: white !important;
}
.open-sidebar-search > .b-sidebar-right {
  animation: sidebar 500ms;
}
@keyframes sidebar {
  0% {
    transform: translateX(500px)
  }
  100% {
    transform: translateX(0px)
  }
}
.container-aspect-ratio {
  position: relative;
}
</style>